var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": _vm.controlEventMode ? "231511" : "231510",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "CargoMsg.Cargo_CustomerQuickSearch"
                ),
                no: "1"
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", no: "2" },
                      on: {
                        click: function($event) {
                          return _vm.addHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.selectedJob || _vm.total <= 0,
                        type: "primary",
                        no: "3"
                      },
                      on: {
                        click: function($event) {
                          return _vm.editHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.selectedJob || _vm.total <= 0,
                        type: "primary",
                        no: "4"
                      },
                      on: {
                        click: function($event) {
                          return _vm.viewHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "5" },
                      on: {
                        click: function($event) {
                          return _vm.printHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "role_CRMCustomerEventManager_exportExcel"
                          ]),
                          expression:
                            "$checkPermission(['role_CRMCustomerEventManager_exportExcel'])"
                        }
                      ],
                      attrs: { type: "primary", no: "6" },
                      on: {
                        click: function($event) {
                          return _vm.btnMenuExcelClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExcelExport")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "23151000",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "has-export-role": _vm.$checkPermission([
                    "role_CRMCustomerEventManager_exportExcel"
                  ]),
                  no: "7"
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: _vm.onGridReady
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "23151001",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  no: "8"
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: {},
          no: "9",
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.editDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                id: "editDialog",
                visible: _vm.editDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_EventRecord"),
                width: "700px",
                "append-to-body": "",
                no: "10",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.editDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "center" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editDialog.isEdit &&
                                _vm.editDialog.state === 1,
                              expression:
                                "editDialog.isEdit && editDialog.state === 1"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerChineseName")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.controlEventMode,
                                expression: "!controlEventMode"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              "filter-type": "global",
                              "default-value": _vm.editDialog.form.name,
                              cache: false,
                              "tag-name": "name",
                              "tag-value": "name",
                              "filter-tag-names": ["name", "englishName"],
                              "options-width": "150px;",
                              "static-options":
                                _vm.editDialog.quotationClientList,
                              no: "11"
                            },
                            on: { parentCallBack: _vm.changeHandler }
                          }),
                          _c("cargo-company-select", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.controlEventMode,
                                expression: "controlEventMode"
                              }
                            ],
                            attrs: {
                              "method-params": { customer: true, active: true },
                              "check-credit": true,
                              job: _vm.editDialog.form,
                              "default-value": _vm.editDialog.form.cmpIdx || "",
                              no: "12"
                            },
                            on: {
                              change: function(p) {
                                _vm.changeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.editDialog.isEdit ||
                                _vm.editDialog.state === 2,
                              expression:
                                "!editDialog.isEdit || editDialog.state === 2"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerChineseName")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: true, no: "13" },
                            model: {
                              value: _vm.editDialog.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "name", $$v)
                              },
                              expression: "editDialog.form.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerEnglishName")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: true, no: "14" },
                            model: {
                              value: _vm.editDialog.form.englishName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "englishName",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.englishName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ClientStatus")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: true,
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_PleaseSelectP"
                                    ),
                                    size: "mini",
                                    no: "15"
                                  },
                                  model: {
                                    value:
                                      _vm.editDialog.form.customerStatusCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editDialog.form,
                                        "customerStatusCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editDialog.form.customerStatusCode"
                                  }
                                },
                                _vm._l(
                                  _vm.CrmCustomerConstants.CUSTOMER_STATUS,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                width: "50%",
                                "margin-left": "10px"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BranchCompany")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "16" },
                                model: {
                                  value: _vm.editDialog.form.branchName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "branchName",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.branchName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { label: _vm.$t("CargoMsg.Cargo_theme") }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.editDialog.isEdit,
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_PleaseSelectP"
                                    ),
                                    size: "mini",
                                    no: "17"
                                  },
                                  model: {
                                    value: _vm.editDialog.form.titleName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editDialog.form,
                                        "titleName",
                                        $$v
                                      )
                                    },
                                    expression: "editDialog.form.titleName"
                                  }
                                },
                                _vm._l(
                                  _vm.CrmCustomerConstants
                                    .CUSTOMER_EVENT_SUBJECTS,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                width: "50%",
                                "margin-left": "10px"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TaskTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetime",
                                  clearable: false,
                                  format: "yyyy-MM-dd HH:mm",
                                  disabled: !(
                                    _vm.editDialog.isEdit &&
                                    _vm.editDialog.isEditTime
                                  ),
                                  editable: false,
                                  no: "18"
                                },
                                model: {
                                  value: _vm.editDialog.form.taskTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "taskTime",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.taskTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Recorder")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "19" },
                                model: {
                                  value: _vm.editDialog.form.recorderName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "recorderName",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.recorderName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                width: "50%",
                                "margin-left": "10px"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_RecordTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm",
                                  disabled: true,
                                  no: "20"
                                },
                                model: {
                                  value: _vm.editDialog.form.recordTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "recordTime",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.recordTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EventStatus")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.editDialog.isEdit,
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_PleaseSelectP"
                                    ),
                                    size: "mini",
                                    no: "21"
                                  },
                                  model: {
                                    value: _vm.editDialog.form.status,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editDialog.form,
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "editDialog.form.status"
                                  }
                                },
                                _vm._l(
                                  _vm.CrmCustomerConstants
                                    .CUSTOMER_EVENT_STATUSS,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                width: "50%",
                                "margin-left": "10px"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Location")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !_vm.editDialog.isEdit,
                                  no: "22"
                                },
                                model: {
                                  value: _vm.editDialog.form.address,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "address",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.address"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_Participant") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: !_vm.editDialog.isEdit,
                              no: "23"
                            },
                            model: {
                              value: _vm.editDialog.form.participants,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "participants",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.participants"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContentDescription")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              disabled: !_vm.editDialog.isEdit,
                              no: "24"
                            },
                            model: {
                              value: _vm.editDialog.form.content,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "content", $$v)
                              },
                              expression: "editDialog.form.content"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Outcomes") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled: !_vm.editDialog.isEdit,
                              no: "25"
                            },
                            model: {
                              value: _vm.editDialog.form.achievement,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "achievement",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.achievement"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_NextStep") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled: !_vm.editDialog.isEdit,
                              no: "26"
                            },
                            model: {
                              value: _vm.editDialog.form.nextTask,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "nextTask", $$v)
                              },
                              expression: "editDialog.form.nextTask"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_ReportTo") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled: !_vm.editDialog.isEdit,
                              no: "27"
                            },
                            model: {
                              value: _vm.editDialog.form.reportTarget,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "reportTarget",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.reportTarget"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled: !_vm.editDialog.isEdit,
                              no: "28"
                            },
                            model: {
                              value: _vm.editDialog.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "remarks", $$v)
                              },
                              expression: "editDialog.form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SupervisorComments")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled:
                                !_vm.editDialog.isEdit ||
                                !_vm.editDialog.editSupervisorComments,
                              no: "29"
                            },
                            model: {
                              value: _vm.editDialog.form.supervisorComments,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "supervisorComments",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.supervisorComments"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editDialog.isEdit,
                          expression: "editDialog.isEdit"
                        }
                      ],
                      attrs: { type: "primary", no: "30" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "31" }, on: { click: _vm.close } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }